export default "__VITE_ASSET__bGgVyq4A__"